export default __webpack_public_path__ + "static/media/feedback.6d4d9296.svg";